import * as React from "react"

import {
  Pane,
  Text,
  majorScale,
  Autocomplete,
  TextInput,
  SideSheet,
  Heading,
  Paragraph,
  Tablist,
  Card,
  Button,
  Tab
} from "evergreen-ui"

import { Alert } from "shards-react"
import { routify } from "../js/routify"

// View Components
import MobileView from "../common/mobileView"
import BrowserView from "../common/browserView"

const URL = "https://form-us1-34745.public.500apps.org/forms/711/email"

function SidesheetApplyForm(props) {
  const [isShown, setIsShown] = React.useState(false)

  return (
    <React.Fragment>
      <SideSheet
        isShown={isShown}
        onCloseComplete={() => setIsShown(false)}
        containerProps={{
          display: "flex",
          flex: "1",
          flexDirection: "column"
        }}
      >
        <Pane zIndex={1} flexShrink={0} elevation={0} backgroundColor="white">
          <Pane padding={16}>
            <Heading size={600}>Application Form</Heading>
          </Pane>
        </Pane>
        <iframe src={URL} style={{ height: "600px" }} />
      </SideSheet>

      <BrowserView>
        <a
          style={{ cursor: "pointer" }}
          className="text-center"
          onClick={() => setIsShown(true)}
        >
          <Alert className="text-center" theme="primary">
            Enroll Now
          </Alert>
        </a>
      </BrowserView>

      <MobileView>
        <a
          className="text-center"
          href={routify(props.countryCode, props.href)}
        >
          <Alert theme="primary">Enroll Now</Alert>
        </a>
      </MobileView>
    </React.Fragment>
  )
}

export default SidesheetApplyForm
